import { api } from "./api";

// Public
export const fetchPublicServices = () => api.get("/services").then((r) => r.data);

// Admin (basic auth)
const authHeader = (user, pass) => ({
  headers: { Authorization: "Basic " + btoa(`${user}:${pass}`) },
});

export const adminListServices = (user, pass) =>
  api.get("/admin/services", authHeader(user, pass)).then((r) => r.data);

export const adminCreateService = (user, pass, body) =>
  api.post("/admin/services", body, authHeader(user, pass)).then((r) => r.data);

export const adminUpdateService = (user, pass, id, body) =>
  api.put(`/admin/services/${id}`, body, authHeader(user, pass)).then((r) => r.data);

export const adminDeleteService = (user, pass, id) =>
  api.delete(`/admin/services/${id}`, authHeader(user, pass)).then((r) => r.data);
